import {
  CHANGE_LOCALE
} from '../actions';
import i18n from '../../services/i18n';

export const changeLocale = (locale) => {
  localStorage.setItem('currentLanguage', locale);
  i18n.changeLanguage(locale);
  return (
    {
      type: CHANGE_LOCALE,
      payload: locale
    }
  );
};

